export interface ISubmitResult {
  score: number;
  passed: boolean;
  correctCount: number;
  totalCount: number;
  passingScore: number;
}

export class SubmitResult {
  score: number;
  passed: boolean;
  correctCount: number;
  totalCount: number;
  passingScore: number;

  constructor(data: ISubmitResult) {
    this.score = data.score;
    this.passed = data.passed;
    this.correctCount = data.correctCount;
    this.totalCount = data.totalCount;
    this.passingScore = data.passingScore;
  }
}
